import { ReadEmployee } from '@/services/gql/graphql.generated';
import { FC } from 'react';
import { ContractDetailsCard } from './TeamMemberContractDetailsCard';
import { PermissionsCard } from './TeamMemberPermissionsCard';
import { PreferedScheduleCard } from './TeamMemberPreferedScheduleCard';
import { WorkRulesCard } from './TeamMemberWorkRulesCard';
import { Feature } from '@/services/backstage/Feature';
import { TeamMemberAvailabilityScheduleCard } from '../overview/TeamMemberAvailabilityScheduleCard';

interface TeamMemberWorkRulesProps {
  employee: ReadEmployee;
  editSchedule?: boolean;
}

export const workRulesSectionId = 'workRulesSectionId';

export const TeamMemberWorkRules: FC<TeamMemberWorkRulesProps> = ({ employee, editSchedule }) => {
  return (
    <section id={workRulesSectionId} className="flex flex-col gap-4">
      <Feature name="availabilitySchedule">
        <TeamMemberAvailabilityScheduleCard employee={employee} enableEdit={editSchedule} />
      </Feature>
      <PermissionsCard employee={employee} />
      <WorkRulesCard employee={employee} />
      <ContractDetailsCard employee={employee} />
    </section>
  );
};
